/**
 * Usuário de login criado nas VMs quando o cliente não informa credenciais.
 *
 * Espelha `DEFAULT_VM_USER` de `backend/app/core/vm_credentials.py`. O portal
 * ANUNCIA este nome ("se não preencher, será criado com usuário X") e o usa como
 * placeholder do campo — foi por seguir esse anúncio que o cliente da issue #226
 * digitou `admin` e levou 422, já que o backend recusava exatamente o nome que a
 * tela sugeria. Ao mudar um lado, mude o outro.
 */
export const DEFAULT_VM_USER = 'cladmin'

/**
 * Conta que existe de fato num Windows Server recém-instalado.
 *
 * Espelha `DEFAULT_WINDOWS_USER` de `backend/app/services/vm_os_service.py`, e NÃO é o que
 * a criação grava em `initial_user` — lá vai o `cladmin` acima, do fluxo de cloud-init
 * Linux, que no Windows nunca chega a ser criado (issue #729). Serve de default ao
 * redefinir a senha. Ao mudar um lado, mude o outro.
 */
export const DEFAULT_WINDOWS_USER = 'Administrator'
